<div class="container-margin">
  <div class="content">
    <h2>{{ translationService.getCreateUserText() }}</h2>
    <div class="container margin-top-40">
      <form [formGroup]="userForm">
        <div class="form-groups">
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getFirstNameText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="firstName"
                  formControlName="firstName"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getLastNameText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="lastName"
                  formControlName="lastName"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getEmailAddressText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="emailAddress"
                  formControlName="email"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{ translationService.getRoleText() }}</mat-label>
                <mat-select
                  formControlName="roleId"
                  (selectionChange)="changeRole()"
                >
                  @for (role of roles; track role) {
                    <mat-option [value]="role.id">{{ role.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          @if (isMasterUser && shouldHaveCompany) {
            <div class="form-group margin-top-10">
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    translationService.getCompanyText()
                  }}</mat-label>
                  <mat-select formControlName="companyId">
                    @for (company of companies; track company) {
                      <mat-option [value]="company.id">{{
                        company.name
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
        </div>
        <div class="actions margin-top-10">
          <button
            mat-raised-button
            extended
            color="primary"
            class="action-item"
            (click)="onSubmit()"
          >
            <mat-icon>add</mat-icon>
            {{ translationService.getSubmitText() }}
          </button>
          <button
            type="button"
            mat-stroked-button
            extended
            color="primary"
            class="action-item"
            (click)="onReset()"
          >
            <mat-icon>refresh</mat-icon>
            {{ translationService.getResetText() }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
